import React from "react";
import { MdCheck, MdDeleteOutline, MdOutlineMail } from "react-icons/md";
import { LuBell } from "react-icons/lu";
import Modal from "./Modal";
import "../../Styles/NotificationPane.css";

export default function NotificationModal({
    isOpen,
    notification,
    onClose,
    onDelete,
    onMarkAsRead,
    onMarkAsUnread
}) {
    if (!isOpen || !notification) return null;

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            ariaLabel="Notification details"
            icon={<LuBell size={20} strokeWidth={2.5} />}
            title={notification.title}
            subtitle={new Date(notification.timestamp).toLocaleString(undefined, { weekday: "long", year: "numeric", month: "long", day: "numeric", hour: "2-digit", minute: "2-digit" })}
            footer={(
                <>
                    <button
                        type="button"
                        className="btn btn-sm btn-link text-danger text-decoration-none px-0 d-inline-flex align-items-center gap-1 fw-medium"
                        onClick={() => {
                            onDelete(notification.id);
                            onClose();
                        }}
                    >
                        <MdDeleteOutline size={15} /> Delete
                    </button>

                    <div className="d-flex flex-wrap gap-2">
                        {!notification.isRead ? (
                            <button
                                type="button"
                                className="btn btn-sm notif-modal-action-btn d-inline-flex align-items-center gap-1.5"
                                onClick={() => {
                                    onMarkAsRead(notification.id);
                                    onClose();
                                }}
                            >
                                <MdCheck size={15} /> Mark as Read
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-sm notif-modal-action-btn d-inline-flex align-items-center gap-1.5"
                                onClick={() => {
                                    onMarkAsUnread(notification.id);
                                    onClose();
                                }}
                            >
                                <MdOutlineMail size={15} /> Mark as Unread
                            </button>
                        )}
                    </div>
                </>
            )}
        >
            <div className="notif-message-box">
                {notification.message}
            </div>
        </Modal>
    );
}
